export default __webpack_public_path__ + "static/ogimage-c144740ca9fcda4bf17518a770899c33.png";